import React, { FC, useEffect, useState } from 'react'
import { Button, Row, Col } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import { NotaryAcknowledgementActionsProps } from './types'

const NotaryAcknowledgementActions: FC<NotaryAcknowledgementActionsProps> = ({
  notaryAcknowledgement,
  submittingAck,
  onSubmit
}) => {
  const [isBelow1240, setIsBelow1240] = useState(false)

  useEffect(() => {
    const update = () => setIsBelow1240(window.innerWidth < 1240)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  if (notaryAcknowledgement) return null
  const actionsMainCol = isBelow1240 ? 24 : 13
  const actionsMainColXxl = isBelow1240 ? 24 : 10
  const clarifyCol = isBelow1240 ? 24 : 14
  const willCorrectCol = isBelow1240 ? 24 : 10
  const willCorrectColXxl = isBelow1240 ? 24 : 8

  return (
    <Row
      align="middle"
      style={{
        width: '100%',
        background: '#fffbe6',
        border: '1px solid #ffe58f',
        borderRadius: 4,
        padding: 12,
        marginBottom: 12
      }}
    >
      <Col
        md={isBelow1240 ? 24 : 11}
        xs={24}
        style={{ paddingBottom: 8 }}
        lg={isBelow1240 ? 24 : 11}
        xxl={isBelow1240 ? 24 : 14}
      >
        <Row gutter={[8, 0]} style={{ gap: 8 }}>
          <Col md={1} xs={1}>
            <InfoCircleFilled style={{ color: '#faad14', fontSize: 18, marginTop: 2 }} />
          </Col>
          <Col md={22} xs={22}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Action required for detected errors</div>
            <div style={{ fontSize: 13, lineHeight: 1.4, color: '#595959' }}>
              Corrections may be required in order to complete the closing. Please confirm that you will address the
              errors below or that you need clarification on these errors.
            </div>
          </Col>
        </Row>
      </Col>

      <Col md={actionsMainCol} xs={24} lg={actionsMainCol} xxl={actionsMainColXxl}>
        <Row gutter={[8, 8]} justify={isBelow1240 ? 'center' : 'end'} style={{ width: '100%', marginTop: 2 }}>
          <Col md={clarifyCol} xs={24} lg={isBelow1240 ? 24 : 14} xxl={willCorrectColXxl}>
            <Button
              loading={submittingAck}
              onClick={() => onSubmit('request_clarification')}
              size="small"
              style={{
                width: '100%',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                height: 'auto',
                minHeight: 30,
                paddingTop: 4,
                paddingBottom: 4,
                maxWidth: 600
              }}
            >
              I need clarification on these errors
            </Button>
          </Col>
          <Col md={willCorrectCol} xs={24} lg={willCorrectCol} xxl={willCorrectColXxl}>
            <Button
              type="primary"
              loading={submittingAck}
              onClick={() => onSubmit('will_correct')}
              size="small"
              style={{
                width: '100%',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                height: 'auto',
                minHeight: 30,
                paddingTop: 4,
                paddingBottom: 4,
                maxWidth: 600
              }}
            >
              I will correct these errors
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default NotaryAcknowledgementActions
